// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f8e32f31","667":"18568ca0","977":"5a09c1fd"}[chunkId] + ".chunk.js";
};